import { render, staticRenderFns } from "./CmgNotificationBar.vue?vue&type=template&id=1dc76058&scoped=true&lang=pug&"
import script from "./cmg-notification-bar.ts?vue&type=script&lang=ts&"
export * from "./cmg-notification-bar.ts?vue&type=script&lang=ts&"
import style0 from "./CmgNotificationBar.vue?vue&type=style&index=0&id=1dc76058&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc76058",
  null
  
)

export default component.exports